import { render, staticRenderFns } from "./PreorderCategories.vue?vue&type=template&id=b58d4e4e&"
import script from "./PreorderCategories.vue?vue&type=script&lang=js&"
export * from "./PreorderCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports